import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import SlideToggle from '../../modules/SlideToggle';

function MasterSearch() {
  const [open, setOpen] = useState(true);
  const { t } = useTranslation();

  const handleOpen = () => {
    setOpen(!open);
  };

  type Inputs = {
    is_master: string;
    master_name: string;
    latest: string;
  };

  const [params, setParams] = useSearchParams();

  const { register, handleSubmit } = useForm<Inputs>({
    defaultValues: {
      is_master: params.get('is_master') || '',
      master_name: params.get('master_name') || '',
      latest: params.get('hidden') || '',
    },
  });
  const onSubmit: SubmitHandler<Inputs> = (data) => {
    setParams({
      is_master: data.is_master,
      master_name: data.master_name,
      latest: data.latest ? '1' : '0',
    });
  };

  return (
    <>
      <h3 className="trig" onClick={handleOpen} style={{ display: 'inline-block' }}>
        <span>
          {t('マスタ検索')}
          <i className={`fa-solid ${open ? 'fa-chevron-down' : 'fa-chevron-up'}`} />
        </span>
      </h3>

      <SlideToggle open={open}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="wfr scondition trigfr fropen">
            <div className="grid3 labip4">
              <div>
                <label htmlFor="my3-1">{t('区分')}</label>
                <span className="dropdown">
                  <select {...register('is_master')}>
                    <option value="">{t('選択してください')}</option>
                    <option value="1">{t('テンプレート')}</option>
                    <option value="2">{t('マスタ')}</option>
                  </select>
                </span>
              </div>
              <div>
                <label htmlFor="master_name">{t('マスタ名')}</label>
                <input type="text" {...register('master_name')} />
              </div>
            </div>
            <div className="controlfr">
              <span className="ck">
                <input type="checkbox" id="latest" {...register('latest')} />{' '}
                <label htmlFor="latest">{t('最新データのみ表示')}</label>
              </span>
              <span>
                <input type="submit" value="検索" className="searchbtn" />
              </span>
            </div>
          </div>
        </form>
      </SlideToggle>
    </>
  );
}

export { MasterSearch };
